'use strict';

/**
 * Collega l'elmento HTML con l'id del componente
 *
 * @param {HTMLElement} el
 * @param {Integer} cid
 */
function setCidToDom(el, cid) {
    el.__cid = cid;
}

module.exports = setCidToDom;
